"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const obstacleDuration = 2500;
exports.default = obstacleDuration;
